<script setup lang="ts">
import { Form, Head, Link } from "@inertiajs/vue3";

import AuthCardShell from "@/components/auth-card-shell.vue";
import { Button } from "@/components/ui/button/index";
import { signInPath, signUpPath } from "@/routes";

defineOptions({ inheritAttrs: false });
</script>

<template>
  <Head title="Registro" />

  <AuthCardShell
    title="Crear cuenta"
    title-class="text-2xl tracking-tight"
    description="Configurá tu organización en un solo paso."
  >
    <Form
      :action="signUpPath()"
      method="post"
      disable-while-processing
      class="inert:pointer-events-none inert:opacity-80"
      :reset-on-error="[
        'registration.password',
        'registration.password_confirmation',
      ]"
      #default="{ errors, processing }"
    >
      <div class="space-y-4">
        <div class="space-y-1.5">
          <label for="registration-email" class="text-sm font-medium"
            >Correo electrónico</label
          >
          <input
            id="registration-email"
            name="registration.email"
            type="email"
            required
            autocomplete="email"
            placeholder="correo@ejemplo.com"
            class="input-field"
          />
          <p
            v-if="errors['registration.email'] || errors.email"
            class="text-sm text-destructive"
          >
            {{ errors["registration.email"] || errors.email }}
          </p>
        </div>

        <div class="space-y-1.5">
          <label for="registration-organization" class="text-sm font-medium"
            >Organización</label
          >
          <input
            id="registration-organization"
            name="registration.organization_name"
            type="text"
            required
            autocomplete="organization"
            placeholder="Nombre de tu organización"
            class="input-field"
          />
          <p
            v-if="
              errors['registration.organization_name'] ||
              errors.organization_name
            "
            class="text-sm text-destructive"
          >
            {{
              errors["registration.organization_name"] ||
              errors.organization_name
            }}
          </p>
        </div>

        <div class="space-y-1.5">
          <label for="registration-password" class="text-sm font-medium"
            >Contraseña</label
          >
          <input
            id="registration-password"
            name="registration.password"
            type="password"
            required
            autocomplete="new-password"
            placeholder="Contraseña"
            class="input-field"
          />
          <p
            v-if="errors['registration.password'] || errors.password"
            class="text-sm text-destructive"
          >
            {{ errors["registration.password"] || errors.password }}
          </p>
        </div>

        <div class="space-y-1.5">
          <label
            for="registration-password-confirm"
            class="text-sm font-medium"
            >Confirmar contraseña</label
          >
          <input
            id="registration-password-confirm"
            name="registration.password_confirmation"
            type="password"
            required
            autocomplete="new-password"
            placeholder="Confirmar contraseña"
            class="input-field"
          />
          <p
            v-if="
              errors['registration.password_confirmation'] ||
              errors.password_confirmation
            "
            class="text-sm text-destructive"
          >
            {{
              errors["registration.password_confirmation"] ||
              errors.password_confirmation
            }}
          </p>
        </div>

        <Button type="submit" :disabled="processing" class="w-full">
          {{ processing ? "Creando cuenta..." : "Crear cuenta" }}
        </Button>
      </div>
    </Form>

    <p class="mt-6 text-center text-sm text-muted-foreground">
      ¿Ya tenés una cuenta?
      <Link
        :href="signInPath()"
        class="font-medium text-foreground underline-offset-4 hover:underline"
        >Iniciar sesión</Link
      >
    </p>
  </AuthCardShell>
</template>
